import { browserHistory } from 'react-router';
import slugify from 'slugify';

export function changeUrl(url: string) {
  browserHistory.push(url);
}

export const base64ToString = atob;
export const stringToBase64 = btoa;

export const getCurrentPath = (toBase64?: boolean) => {
  const { pathname, search, hash } = browserHistory.getCurrentLocation();
  const path = pathname + search + hash;
  return toBase64 ? stringToBase64(path) : path;
};

export const isBase64 = (str: string) => {
  try {
    return stringToBase64(base64ToString(str)) === str;
  } catch (err) {
    return false;
  }
};

export function toProgramLandingPageUrl(program: {
  id: number;
  name?: string;
  influencer?: {
    customURL?: string;
    customDomains?: Array<{
      id: number;
      domain: string;
      status: string;
    }> | null;
  };
}) {
  if (!program) {
    throw new Error('Program not defined in programUrl');
  }

  if (!program.influencer) {
    throw new Error('Influencer not defined in programUrl');
  }

  const nameSlug = slugify(program.name, {
    lower: true,
    strict: true,
  });

  const domain = getDomain(program.influencer);
  const baseUrl = domain
    ? domain
    : `${import.meta.env.VITE_LANDING_PAGE_URL}/${
        program.influencer.customURL
      }`;

  return `${baseUrl}/programs/${encodeURIComponent(nameSlug)}/${program.id}`;
}

export function toProgramCheckoutUrl(program: {
  id: number;
  name?: string;
  influencer?: {
    customURL?: string;
    customDomains?: Array<{
      id: number;
      domain: string;
      status: string;
    }> | null;
  };
}) {
  const programUrl = toProgramLandingPageUrl(program);
  return `${programUrl}/checkout`;
}

export function toSubscriptionPurchasePage(influencer: {
  customURL?: string;
  customDomains?: Array<{
    id: number;
    domain: string;
    status: string;
  }> | null;
}) {
  if (!influencer) {
    throw new Error('influencer not defined in toSubscriptionPurchasePage');
  }
  const customURL = influencer?.customURL || '';
  if (!customURL) return '';
  const domain =
    getDomain(influencer) ||
    `${import.meta.env.VITE_LANDING_PAGE_URL}/${customURL}`;
  return `${domain}/checkout`;
}

export function getDomain(influencer: {
  customDomains?: Array<{
    id: number;
    domain: string;
    status: string;
  }>;
}) {
  if (!influencer) {
    throw new Error('influencer not defined in getDomain');
  }

  const usedDomain = (influencer.customDomains || [])?.find(
    (domain) => domain.status === 'InfraRunning',
  );

  return usedDomain ? `https://${usedDomain.domain}` : null;
}
